import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

export const Tags = {
  read: (locale, callback) => {
    const accessToken = btoa(publicConfig.env_handshake);

    const requestParams = {
      host: ssoHost,
      path: `/v1/env/tags/${locale}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      null,
    );
  },
};
